<template>
  <div class="card card-body p-0 mb-3">
    <div class="table-responsive">
      <table class="table table-striped m-0 text-start" aria-label="Admin">
        <thead>
          <tr>
            <th scope="col">Name</th>
            <th scope="col" class="text-end">Last Updated</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="entry in entries" :key="entry.id">
            <td>{{ entry.fullname }}</td>
            <td class="text-end">{{ entry.tsUpdatedLabel }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
/*
 * If you need to display specific data properties,
 * you can add in new <td> with `entry.value`, for example.
 */
export default {
  name: "AdminTable",
  props: {
    entries: Array
  }
};
</script>
